<template>
  <div class="code-info">
    <div class="code-intro">{{ employeeInfo.nickname }}，Your activity authorization code is<span class="anth-code">{{ employeeInfo.code }}</span>, <br />Please keep it safe as it is needed for future access</div>
    <div ref="qrCodeRef" class="img-code"></div>
    <div>Long Press to Save Your Participation Code</div>
    <div class="activity-btn" @click="toUrl">Enter Event</div>
    <img class="img-tip" src="@/assets/images/save_tip.png" alt="">
    <div class="bottom-tip">Add this website to your favorites or home screen for easier access next time.</div>
  </div>
</template>

<script>
import { activityEmployeeQrCodeApi, activityEmployeeInfoApi } from '@/api'
import { Toast } from 'vant'
import { mapState, mapMutations } from 'vuex'
import QRCode from 'qrcodejs2'
export default {
  data () {
    return {
      employeeInfo: {},
      qrcodeUrl: null
    }
  },
  computed: {
    ...mapState({
      userInfo: 'myUserInfo'
    })
  },
  created () {
    this.getEmployeeInfoData()
  },
  mounted () {
    this.getCodeData()
  },
  methods: {
    ...mapMutations(['setActivityInfo']),
    getCodeData () {
      activityEmployeeQrCodeApi(this.userInfo.user.id).then(res => {
        this.qrcodeUrl = new QRCode(this.$refs.qrCodeRef, {
          text: res.data,
          width: this.$refs.qrCodeRef.offsetWidth,
          height: this.$refs.qrCodeRef.offsetHeight,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: QRCode.CorrectLevel.M
        })
      })
    },
    getEmployeeInfoData () {
      Toast.loading({
        message: 'loading...',
        forbidClick: true,
        duration: 0
      })
      activityEmployeeInfoApi(this.userInfo.user.id).then(res => {
        Toast.clear()
        this.employeeInfo = res.data
      })
    },
    toUrl () {
      this.$router.push('/activity')
    }
  }
}
</script>

<style lang="less" scoped>
.code-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 26px 16px;
  font-size: 12px;
  color: #333;
  .code-intro {
    text-align: center;
    font-size: 15px;
    .anth-code {
      font-size: 17px;
      color: #ee541b;
      font-weight: bold;
    }
  }
  .img-code {
    width: 192px;
    height: 192px;
    margin: 5px 0;
  }
  .activity-btn {
    width: 296px;
    height: 47px;
    margin-top: 10px;
    margin-bottom: 16px;
    line-height: 47px;
    text-align: center;
    font-size: 17px;
    color: #fff;
    background-color: #ee541b;
    border-radius: 20px;
  }
  .img-tip {
    width: 256px;
    margin-bottom: 10px;
  }
  .bottom-tip {
    text-align: center;
    color: #7f7f7f;
  }
}
</style>
